import type { PlatformAdapter } from "./platformAdapter";

/** Browser implementation (dev preview today; future web build). */
export function createBrowserPlatformAdapter(): PlatformAdapter {
  return {
    async pickFile(options) {
      return new Promise((resolve) => {
        const input = document.createElement("input");
        input.type = "file";
        if (options?.extensions?.length) {
          input.accept = options.extensions.map((e) => (e === "*" ? "" : `.${e}`)).filter(Boolean).join(",");
        }
        input.onchange = async () => {
          const file = input.files?.[0];
          if (!file) return resolve(null);
          resolve({ bytes: new Uint8Array(await file.arrayBuffer()), filename: file.name });
        };
        input.click();
      });
    },
    async openExternalUrl(url) {
      window.open(url, "_blank", "noopener");
    },
    async saveFile(request) {
      const url = URL.createObjectURL(new Blob([request.bytes as BlobPart], { type: request.mimeType }));
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = request.defaultName;
      anchor.click();
      URL.revokeObjectURL(url);
      return "";
    },
    print() {
      window.print();
    },
    async openManagedFile(_absolutePath, fallback) {
      const bytes = await fallback.bytes();
      const url = URL.createObjectURL(new Blob([bytes as BlobPart], { type: fallback.mimeType }));
      window.open(url, "_blank");
    },
  };
}
